import * as React from "react";
import { P_Props } from "./CustomStatus.type";

const CustomStatusPresenter: React.FC<P_Props> = (props) => {
  const className = "custom-status";
  const sizeClass = props.size === "large" ? ` ${className}-lg` : "";
  return (
    <div className={`custom-status${sizeClass}`} style={props.style}>
      <div
        className="custom-status__icon"
        style={{ backgroundColor: props.color }}
      ></div>
      {props.title && <div className="custom-status__title">{props.title}</div>}
    </div>
  );
};

export default CustomStatusPresenter;
